<template>
  <el-autocomplete
    ref="third"
    placeholder="Buscar persona..."
    v-model="thirdSearch"
    :fetch-suggestions="querySearchAsync"
    @select="handleSelect"
    @clear="clear"
    :trigger-on-focus="false"
    clearable
    size="medium"
    style="width: 100%"
  >
    <template slot="prepend"><i class="el-icon-user-solid"></i></template>
    <template slot="suffix">
      <el-button @click="addThird" class="mt-5" icon="el-icon-plus" size="mini" plain circle></el-button>
    </template>
      <template slot-scope="{ item }">
        <div class style="line-height: 1; padding: 5px 0 5px">
          <i class="mdi mdi-account"></i>
          {{ item.nombre }}
          <br />
          <small>
            <i class="mdi mdi-clipboard-account"></i>
            {{ item.documento }}
          </small>
        </div>
      </template>
  </el-autocomplete>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import { searchPerson } from "@/api/person"
export default {
  data(){
    return {
      personSearch: {},
    }
  },
  computed:{
    ...mapGetters(['third']),
    thirdSearch: {
      get () { return this.third.name },
      set (value) { this['third/SET_THIRD']({value: value, prop: 'name'}) }
    }
  },
  methods: {
    ...mapMutations([
      'setRightMenu', 'third/RESET_THIRD', 'third/SET_THIRD', 'inputAndOutputAdjust/SET_THIRD_ID',
    ]),
    addThird(){
      this.setRightMenu({
        componentActive: 'third-form-component',
        drawer: true,
        data: {
          icon: 'package-variant',
          title: 'Agregar tercero',
          btnRemove: false,
          field_id: null,
          hidden_btn: true,
          edit: false,
        }
      })
    },
    querySearchAsync(queryString, cb) {
      if (queryString && queryString.length > 3) {
        searchPerson(queryString, "cliente")
          .then(({ data }) => {
            cb(data.data);
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    handleSelect(item) {
      this['inputAndOutputAdjust/SET_THIRD_ID'](item.id)
      this['third/SET_THIRD']({value: item, prop: 'all'})
    },
    clear() {
      this['inputAndOutputAdjust/SET_THIRD_ID'](null)
      this['third/RESET_THIRD']()
    },
  },
}
</script>